import React from 'react';
import PropTypes from 'prop-types';
import MySettings from './screens/MySettings';
import EditUser from './screens/EditUser';
import CreateUser from './screens/CreateUser';
import * as actions from './UserForm.ducks';

export { default as reducer } from './UserForm.ducks';
export { default as sagas } from './UserForm.sagas';
export { backToUsers } from './screens/navigation';
export { actions };

const SCREENS = { mySettings: MySettings, edit: EditUser, create: CreateUser };

const UserFormScreen = ({ screen, ...props }) => {
  const Screen = SCREENS[screen] || MySettings;
  return <Screen {...props} />;
};

UserFormScreen.propTypes = { screen: PropTypes.oneOf(['mySettings', 'edit', 'create']).isRequired };

export default UserFormScreen;
